module.exports = __webpack_public_path__ + "static/img/footer.12ea18b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer.svg
// module id = AUAY
// module chunks = 22